<template>
  <b-card
    no-body
    class="data-total-area"
  >
    <div
      v-if="onProgress"
      class="data-loading d-flex justify-content-center"
    >
      <b-spinner
        class="mt-1"
        label="Loading"
      />
    </div>
    <card-statistic-horizontal
      icon="UserCheckIcon"
      :statistic="total"
      statistic-title="Page View"
      :statistic-sub-title="pvTotalComparedToSevenDayAgo"
      :statistic-icon="comparedToSevenDaysAgoPvIcon"
      :statistic-icon-color="comparedToSevenDaysAgoPvIconColor"
      :statistic-negative-sign="comparedToSevenDaysAgoPvNegativeSign"
    />
    <div
      v-if="userStatisticsSevenDaysAgoOnProgress"
      class="data-loading d-flex justify-content-center"
    >
      <b-spinner
        class="mt-1"
        label="Loading"
      />
    </div>
    <div
      v-else
    >
      <card-statistic-horizontal
        v-if="userStatistics && userTotal"
        icon="UserCheckIcon"
        :statistic="userTotal"
        statistic-title="Users"
        :statistic-sub-title="userTotalComparedToSevenDayAgo"
        :statistic-icon="comparedToSevenDaysAgoUserIcon"
        :statistic-icon-color="comparedToSevenDaysAgoUserIconColor"
        :statistic-negative-sign="comparedToSevenDaysAgoUserNegativeSign"
        :logged-in-users-total="loggedInTotal"
      />
      <card-statistic-horizontal
        v-if="userStatistics && sessionTotal"
        icon="UserCheckIcon"
        :statistic="sessionTotal"
        statistic-title="Sessions"
        :statistic-sub-title="sessionTotalComparedToSevenDayAgo"
        :statistic-icon="comparedToSevenDaysAgoSessionIcon"
        :statistic-icon-color="comparedToSevenDaysAgoSessionIconColor"
        :statistic-negative-sign="comparedToSevenDaysAgoSessionNegativeSign"
      />
    </div>
    <b-row
      class="mt-1 ml-2"
    >
      <b-col
        v-for="(data,index) in devices"
        :key="`${data.name}-${index}`"
        v-b-tooltip.hover
        class="align-items-center"
        cols="4"
        :title="`${ data.usage }%`"
      >
        <feather-icon
          :icon="data.icon"
          size="10"
          :class="`${ data.iconColor} align-items-center    `"
        />
        <span
          class="ml-25 font-small-2"
        >{{ data.name }}</span>
      </b-col>
    </b-row>
    <b-card-body>
      <b-progress
        :max="max"
        height="20px"
      >
        <b-progress-bar
          variant="success"
          :value="series[0]"
          show-progress
        />
        <b-progress-bar
          variant="primary"
          :value="series[1]"
          show-progress
        />
        <b-progress-bar
          variant="warning"
          :value="series[2]"
          show-progress
        />
      </b-progress>
      <!-- chart info -->
      <b-row class="mt-2 pt-1 border-top">
        <b-col>
          <b-card-title>
            Top Screens
          </b-card-title>
        </b-col>
      </b-row>
      <b-row
        v-for="(data,index) in breadcrumbs"
        :key="data.name"
        class="d-flex justify-content-between"
        :class="index === breadcrumbs.length - 1 ? 'mb-0':'mb-1'"
      >
        <b-col
          class="d-flex justify-content-start"
        >
          {{ data.name }}
        </b-col>
        <b-col
          class="d-flex justify-content-end"
        >
          {{ data.usage }}
        </b-col>
      </b-row>
      <!--      <div class="d-flex" >-->
      <!--        <b-button-->
      <!--          v-ripple.400="'rgba(40, 199, 111, 0.15)'"-->
      <!--          variant="flat-success"-->
      <!--          @click="breadcrumbExtend()"-->
      <!--          class="btn-icon ml-auto"-->
      <!--        >-->
      <!--          <feather-icon :icon="breadcrumbsExtendIcon" />-->
      <!--        </b-button>-->
      <!--      </div>-->
    </b-card-body>
  </b-card>
</template>

<script>
import {
    BCard, BCardTitle, BCardBody, BProgressBar, BProgress, BButton, BSpinner, VBTooltip, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getCoreApiByObjectId, getCoreApiLatestObject } from '@/coreApi/coreApiHelper'
import CardStatisticHorizontal from '@/views/card/statistics-cards/CardStatisticHorizontal.vue'

export default {
    components: {
        BCard,
        BCardTitle,
        BCardBody,
        BProgressBar,
        BProgress,
        BButton,
        BSpinner,
        BRow,
        BCol,
        CardStatisticHorizontal,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        dataObject: {
            type: Object,
            default: () => {},
        },
        onProgress: {
            type: Boolean,
            default: true,
        },
        userStatistics: {
            type: Object,
            default: () => {},
        },
        userStatisticsOnProgress: {
            type: Boolean,
            default: true,
        },
        pvSevenDaysAgo: {
            type: Object,
            default: () => {},
        },
        pvSevenDaysAgoOnProgress: {
            type: Boolean,
            default: true,
        },
        userStatisticsSevenDaysAgo: {
            type: Object,
            default: () => {},
        },
        userStatisticsSevenDaysAgoOnProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            devices: this.defaultDevices(),
            breadcrumbs: this.defaultBreadcrumbs(),
            breadcrumbsAll: this.defaultBreadcrumbs(),
            breadcrumbsExtendIcon: 'ChevronUpIcon',
            series: this.defaultSeries(),
            max: 100,
            total: 0,
            newTotal: 0,
            userTotal: 0,
            newUserTotal: 0,
            loggedInTotal: 0,
            sessionTotal: 0,
            newSessionTotal: 0,
            pvTotalComparedToSevenDayAgo: 0,
            comparedToSevenDaysAgoPvIcon: null,
            comparedToSevenDaysAgoPvIconColor: null,
            comparedToSevenDaysAgoPvNegativeSign: null,
            userTotalComparedToSevenDayAgo: 0,
            comparedToSevenDaysAgoUserIcon: null,
            comparedToSevenDaysAgoUserIconColor: null,
            comparedToSevenDaysAgoUserNegativeSign: null,
            sessionTotalComparedToSevenDayAgo: 0,
            comparedToSevenDaysAgoSessionIcon: null,
            comparedToSevenDaysAgoSessionIconColor: null,
            comparedToSevenDaysAgoSessionNegativeSign: null,
        }
    },

    watch: {
        dataObject() {
            const object = getCoreApiByObjectId(this.dataObject, 'statistics')
            let data = null
            if (
                object
                && object.data
                && object.data.at(-1)
            ) {
                data = object.data.at(-1)
            }
            if (data) {
                let total = 0
                if (data.total) {
                    total = data.total
                    this.newTotal = data.total
                } else {
                    this.newTotal = 0
                }
                if (data.devices) {
                    const devices = JSON.parse(data.devices)

                    if (devices && total) {
                        this.devices = this.defaultDevices()
                        this.series = this.defaultSeries()
                        devices.forEach(device => {
                            // eslint-disable-next-line no-mixed-operators
                            let deviceRatio = device.device_total / total * 100
                            deviceRatio = deviceRatio.toFixed(1)
                            this.devices.forEach((deviceItem, index) => {
                                if (deviceItem.name.toLowerCase() === device.device) {
                                    this.devices[index].usage = deviceRatio
                                    // eslint-disable-next-line radix
                                    this.series[index] = parseInt(deviceRatio)
                                }
                            })
                        })
                    } else {
                        this.devices = this.defaultDevices()
                        this.series = this.defaultSeries()
                    }
                } else {
                    this.devices = this.defaultDevices()
                    this.series = this.defaultSeries()
                }

                if (data.breadcrumbs) {
                    const breadcrumbs = JSON.parse(data.breadcrumbs)
                    const currentBreadcrumbs = []

                    if (breadcrumbs && total) {
                        const breadcrumbsData = {
                            homepage: {
                                breadcrumb: 'Homepage',
                                breadcrumb_total: 0,
                            },
                            content: {
                                breadcrumb: 'Content',
                                breadcrumb_total: 0,
                            },
                            gallery: {
                                breadcrumb: 'Gallery',
                                breadcrumb_total: 0,
                            },
                            other: {
                                breadcrumb: 'Other',
                                breadcrumb_total: 0,
                            },
                        }

                        let sumContents = 0
                        let breadcrumbName = ''
                        breadcrumbs.forEach(breadcrumb => {
                            breadcrumbName = 'NotExist'
                            if (breadcrumb && typeof breadcrumb.breadcrumb !== 'undefined') {
                                breadcrumbName = breadcrumb.breadcrumb.toLowerCase()
                            }

                            if (typeof breadcrumbsData[breadcrumbName] !== 'undefined') {
                                breadcrumbsData[breadcrumbName].breadcrumb_total += breadcrumb.breadcrumb_total
                                sumContents += breadcrumb.breadcrumb_total
                            } else {
                                breadcrumbsData.other.breadcrumb_total += breadcrumb.breadcrumb_total
                            }
                        })

                        breadcrumbsData.other.breadcrumb_total = total - sumContents

                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for (const breadcrumbKey in breadcrumbsData) {
                            currentBreadcrumbs.push({
                                name: breadcrumbsData[breadcrumbKey].breadcrumb,
                                usage: breadcrumbsData[breadcrumbKey].breadcrumb_total.toLocaleString(),
                            })
                        }
                    }
                    if (this.breadcrumbs.length > 0 && this.breadcrumbs.length === this.breadcrumbsAll.length) {
                        this.breadcrumbs = currentBreadcrumbs
                        this.breadcrumbsAll = currentBreadcrumbs
                    } else {
                        this.breadcrumbs = currentBreadcrumbs.slice(0, 5)
                        this.breadcrumbsAll = currentBreadcrumbs
                    }
                } else {
                    this.breadcrumbs = this.defaultBreadcrumbs()
                    this.breadcrumbsAll = this.defaultBreadcrumbs()
                }
                this.calculatePvSevenDaysAgo()
            } else {
                this.newTotal = 0
                this.devices = this.defaultDevices()
                this.series = this.defaultSeries()
                this.breadcrumbs = this.defaultBreadcrumbs()
                this.breadcrumbsAll = this.defaultBreadcrumbs()
            }
            this.changeTotalPv(1)
        },
        pvSevenDaysAgo() {
            this.calculatePvSevenDaysAgo()
        },
        userStatistics() {
            this.calculateUserStatisticsSelectedDay()
        },
        userStatisticsSevenDaysAgo() {
            this.calculateUserStatisticsSevenDaysAgo()
        },
    },
    methods: {
        calculateUserStatisticsSelectedDay() {
            const latestObject = getCoreApiLatestObject(this.userStatistics)
            let data = null
            if (
                latestObject
            && latestObject.data
            && latestObject.data.at(-1)
            ) {
                data = latestObject.data.at(-1)
            }
            if (data) {
                // eslint-disable-next-line no-unused-vars
                let userTotal = 0
                // eslint-disable-next-line no-unused-vars
                let sessionTotal = 0

                this.userTotal = 0
                this.sessionTotal = 0

                if (data.userTotal) {
                    userTotal = data.userTotal
                    this.newUserTotal = data.userTotal
                } else {
                    this.newUserTotal = 0
                }
                if (data.sessionTotal) {
                    sessionTotal = data.sessionTotal
                    this.newSessionTotal = data.sessionTotal
                } else {
                    this.newSessionTotal = 0
                }
                if (data.loggedInTotal) {
                    this.loggedInTotal = data.loggedInTotal
                } else {
                    this.loggedInTotal = 0
                }
                this.calculateUserStatisticsSevenDaysAgo()
            } else {
                this.userTotal = 0
                this.newUserTotal = 0
                this.sessionTotal = 0
                this.newSessionTotal = 0
                this.loggedInTotal = 0
            }
            this.changeUserTotal(1)
            this.changeSessionTotal(1)
        },
        calculateUserStatisticsSevenDaysAgo() {
            const objectUserStatisticsSevenDaysAgo = getCoreApiByObjectId(this.userStatisticsSevenDaysAgo, 'userStatisticsSevenDaysAgo')
            let data = null
            let increaseUserValue = 0
            let decreaseUserValue = 0
            let sumSevenDaysAgoUserCount = 0
            let sumCurrentUserCount = 0
            let increaseSessionValue = 0
            let decreaseSessionValue = 0
            let sumSevenDaysAgoSessionCount = 0
            let sumCurrentSessionCount = 0
            if (
                objectUserStatisticsSevenDaysAgo
                && objectUserStatisticsSevenDaysAgo.data
                && objectUserStatisticsSevenDaysAgo.data.at(-1)
            ) {
                data = objectUserStatisticsSevenDaysAgo.data.at(-1)
            }
            if (data) {
                sumSevenDaysAgoUserCount = data.userTotal
                sumCurrentUserCount = this.newUserTotal

                if (sumSevenDaysAgoUserCount && sumCurrentUserCount) {
                    if (sumSevenDaysAgoUserCount < sumCurrentUserCount) {
                        increaseUserValue = Math.round(sumCurrentUserCount - sumSevenDaysAgoUserCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.userTotalComparedToSevenDayAgo = `${((increaseUserValue / sumSevenDaysAgoUserCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoUserIcon = 'ArrowUpIcon'
                        this.comparedToSevenDaysAgoUserIconColor = 'text-success'
                        this.comparedToSevenDaysAgoUserNegativeSign = ''
                    } else {
                        decreaseUserValue = Math.round(sumSevenDaysAgoUserCount - sumCurrentUserCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.userTotalComparedToSevenDayAgo = `${((decreaseUserValue / sumSevenDaysAgoUserCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoUserIcon = 'ArrowDownIcon'
                        this.comparedToSevenDaysAgoUserIconColor = 'text-danger'
                        this.comparedToSevenDaysAgoUserNegativeSign = '-'
                    }
                } else {
                    this.userTotalComparedToSevenDayAgo = null
                    this.comparedToSevenDaysAgoUserIcon = null
                    this.comparedToSevenDaysAgoUserIconColor = null
                    this.comparedToSevenDaysAgoUserNegativeSign = null
                }
                sumSevenDaysAgoSessionCount = data.sessionTotal
                sumCurrentSessionCount = this.newSessionTotal
                if (sumSevenDaysAgoSessionCount && sumCurrentSessionCount) {
                    if (sumSevenDaysAgoSessionCount < sumCurrentSessionCount) {
                        increaseSessionValue = Math.round(sumCurrentSessionCount - sumSevenDaysAgoSessionCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.sessionTotalComparedToSevenDayAgo = `${((increaseSessionValue / sumSevenDaysAgoSessionCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoSessionIcon = 'ArrowUpIcon'
                        this.comparedToSevenDaysAgoSessionIconColor = 'text-success'
                        this.comparedToSevenDaysAgoSessionNegativeSign = ''
                    } else {
                        decreaseSessionValue = Math.round(sumSevenDaysAgoSessionCount - sumCurrentSessionCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.sessionTotalComparedToSevenDayAgo = `${((decreaseSessionValue / sumSevenDaysAgoSessionCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoSessionIcon = 'ArrowDownIcon'
                        this.comparedToSevenDaysAgoSessionIconColor = 'text-danger'
                        this.comparedToSevenDaysAgoSessionNegativeSign = '-'
                    }
                } else {
                    this.sessionTotalComparedToSevenDayAgo = null
                    this.comparedToSevenDaysAgoSessionIcon = null
                    this.comparedToSevenDaysAgoSessionIconColor = null
                    this.comparedToSevenDaysAgoSessionNegativeSign = null
                }
            }
        },
        calculatePvSevenDaysAgo() {
            const objectPvSevenDaysAgo = getCoreApiByObjectId(this.pvSevenDaysAgo, 'sevenDaysAgo')
            let sumSevenDaysAgoPvCount = 0
            let sumCurrentPvCount = 0
            let increasePvValue = 0
            let decreasePvValue = 0
            if (
                objectPvSevenDaysAgo
                && 'data' in objectPvSevenDaysAgo
            ) {
                objectPvSevenDaysAgo.data.forEach(obj => {
                    // eslint-disable-next-line radix
                    sumSevenDaysAgoPvCount += parseInt(obj.y)
                })
                if (sumSevenDaysAgoPvCount) {
                    sumCurrentPvCount = this.newTotal
                    if (sumSevenDaysAgoPvCount < sumCurrentPvCount) {
                        increasePvValue = Math.round(sumCurrentPvCount - sumSevenDaysAgoPvCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.pvTotalComparedToSevenDayAgo = `${((increasePvValue / sumSevenDaysAgoPvCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoPvIcon = 'ArrowUpIcon'
                        this.comparedToSevenDaysAgoPvIconColor = 'text-success'
                        this.comparedToSevenDaysAgoPvNegativeSign = ''
                    } else {
                        decreasePvValue = Math.round(sumSevenDaysAgoPvCount - sumCurrentPvCount)
                        // eslint-disable-next-line no-mixed-operators
                        this.pvTotalComparedToSevenDayAgo = `${((decreasePvValue / sumSevenDaysAgoPvCount) * 100).toFixed(2)}%`
                        this.comparedToSevenDaysAgoPvIcon = 'ArrowDownIcon'
                        this.comparedToSevenDaysAgoPvIconColor = 'text-danger'
                        this.comparedToSevenDaysAgoPvNegativeSign = '-'
                    }
                }
            }
        },
        defaultDevices() {
            return [
                {
                    icon: 'CircleIcon',
                    name: 'Mobile',
                    iconColor: 'text-success',
                    usage: 0,
                    upDown: 0,
                },
                {
                    icon: 'CircleIcon',
                    name: 'Desktop',
                    iconColor: 'text-primary',
                    usage: 0,
                    upDown: 0,
                },
                {
                    icon: 'CircleIcon',
                    name: 'Tablet',
                    iconColor: 'text-warning',
                    usage: 0,
                    upDown: 0,
                },
            ]
        },
        defaultBreadcrumbs() {
            return []
        },
        defaultSeries() {
            return [0, 0, 0]
        },
        breadcrumbExtend() {
            if (this.breadcrumbs.length === this.breadcrumbsAll.length) {
                this.breadcrumbs = this.breadcrumbsAll.slice(0, 5)
                this.breadcrumbsExtendIcon = 'ChevronUpIcon'
            } else {
                this.breadcrumbs = this.breadcrumbsAll
                this.breadcrumbsExtendIcon = 'ChevronDownIcon'
            }
        },
        changeTotalPv(changeQuantity) {
            const difference = this.total - this.newTotal

            if (Math.abs(difference) > changeQuantity) {
                let change = changeQuantity
                if (difference > 0) {
                    change = changeQuantity * -1
                }

                this.total += change
                this.animateChangeTotalPv()
            } else {
                this.total = this.newTotal
            }
        },
        changeUserTotal(changeQuantity) {
            const difference = this.userTotal - this.newUserTotal

            if (Math.abs(difference) > changeQuantity) {
                let change = changeQuantity
                if (difference > 0) {
                    change = changeQuantity * -1
                }

                this.userTotal += change
                this.animateChangeUserTotal()
            } else {
                this.userTotal = this.newUserTotal
            }
        },
        changeSessionTotal(changeQuantity) {
            const difference = this.sessionTotal - this.newSessionTotal

            if (Math.abs(difference) > changeQuantity) {
                let change = changeQuantity
                if (difference > 0) {
                    change = changeQuantity * -1
                }

                this.sessionTotal += change
                this.animateChangeSessionTotal()
            } else {
                this.sessionTotal = this.newSessionTotal
            }
        },
        animateChangeTotalPv() {
            const difference = Math.abs(this.total - this.newTotal)
            let timeDelay = 0
            let changeQuantity = 1

            if (difference > 1000000) {
                changeQuantity = 1000000
                timeDelay = 2
            } else if (difference > 100000) {
                changeQuantity = 100000
                timeDelay = 5
            } else if (difference > 10000) {
                changeQuantity = 1000
                timeDelay = 8
            } else if (difference > 5000) {
                changeQuantity = 300
                timeDelay = 12
            } else if (difference > 1000) {
                changeQuantity = 100
                timeDelay = 16
            } else if (difference > 100) {
                changeQuantity = 20
                timeDelay = 20
            } else if (difference > 10) {
                changeQuantity = 1
                timeDelay = 30
            }

            if (difference > 0) {
                setTimeout(() => {
                    this.changeTotalPv(changeQuantity)
                }, timeDelay)
            }
        },
        animateChangeUserTotal() {
            const difference = Math.abs(this.userTotal - this.newUserTotal)
            let timeDelay = 0
            let changeQuantity = 1

            if (difference > 1000000) {
                changeQuantity = 1000000
                timeDelay = 2
            } else if (difference > 100000) {
                changeQuantity = 100000
                timeDelay = 5
            } else if (difference > 10000) {
                changeQuantity = 1000
                timeDelay = 8
            } else if (difference > 5000) {
                changeQuantity = 300
                timeDelay = 12
            } else if (difference > 1000) {
                changeQuantity = 100
                timeDelay = 16
            } else if (difference > 100) {
                changeQuantity = 20
                timeDelay = 20
            } else if (difference > 10) {
                changeQuantity = 1
                timeDelay = 30
            }

            if (difference > 0) {
                setTimeout(() => {
                    this.changeUserTotal(changeQuantity)
                }, timeDelay)
            }
        },
        animateChangeSessionTotal() {
            const difference = Math.abs(this.sessionTotal - this.newSessionTotal)
            let timeDelay = 0
            let changeQuantity = 1

            if (difference > 1000000) {
                changeQuantity = 1000000
                timeDelay = 2
            } else if (difference > 100000) {
                changeQuantity = 100000
                timeDelay = 3
            } else if (difference > 10000) {
                changeQuantity = 1000
                timeDelay = 8
            } else if (difference > 5000) {
                changeQuantity = 300
                timeDelay = 12
            } else if (difference > 1000) {
                changeQuantity = 100
                timeDelay = 16
            } else if (difference > 100) {
                changeQuantity = 20
                timeDelay = 20
            } else if (difference > 10) {
                changeQuantity = 1
                timeDelay = 30
            }

            if (difference > 0) {
                setTimeout(() => {
                    this.changeSessionTotal(changeQuantity)
                }, timeDelay)
            }
        },
    },
}
</script>
<style>
.progress {
    border-radius: 5px;
}
</style>
